import { object, string } from "yup"
import { withFormik } from "formik"

import AddAdminFormContent from "./AddAdminFormContent"

const AddAdminForm = withFormik({
  mapPropsToValues() {
    return {
      email: "",
      full_name: "",
    }
  },

  validationSchema: () =>
    object().shape({
      email: string()
        .trim()
        .required("Please enter email address")
        .email(
          "Please enter your email address in format yourname@example.com",
        )
        .max(
          64,
          "Please enter a valid email address that consists of no more than 64 characters",
        ),
      full_name: string()
        .trim()
        .min(2, "Please enter a correct full name that consists of a minimum 2 characters")
        .max(200, "Please enter a correct full name that consists of no more than 200 characters"),
    }),

  handleSubmit(
    values,
    { setSubmitting, setFieldError, props: { onConfirm, closeForm } },
  ) {
    // Extract name from email if full_name is not provided
    let full_name = values.full_name
    if (!full_name || full_name.trim() === "") {
      const emailParts = values.email.split("@")
      if (emailParts.length > 0) {
        const namePart = emailParts[0]
        // Capitalize first letter and replace dots/underscores with spaces
        full_name = namePart
          .replace(/[._]/g, " ")
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ")
      }
    }

    onConfirm({ email: values.email, full_name: full_name || "Admin User" })
      .then(() => {
        closeForm()
      })
      .catch((data) => {
        if (data.error) {
          let errorTxt = data.error

          if (
            errorTxt === "That email address is already taken. Try another one" ||
            errorTxt === "This email address belongs to an existing user. Please try a different one."
          ) {
            errorTxt =
              "Please enter email address which doesn't belong to another user."
          }

          setFieldError("email", errorTxt)
        }
      })
      .finally(() => setSubmitting(false))
  },
})(AddAdminFormContent)

export default AddAdminForm

